import React, { useState } from "react";
import { Button } from "components/atoms/Button";
import { ButtonType } from "components/atoms/Button/types";
import { Modal } from "components/atoms/Modal";
import { CompetitionGallery } from "components/molecules/CompetitionGallery";
import * as Styled from "./ImageSelectionModal.styled";
interface ImageSelectionModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (imageId: string) => void;
  userGallery: boolean;
  defaultFilters?: {
    [key: string]: string;
  };
  createdAtBefore?: string;
}
const ImageSelectionModal: React.FC<ImageSelectionModalProps> = ({
  open,
  onClose,
  onSelect,
  userGallery,
  defaultFilters,
  createdAtBefore
}) => {
  const [selectedImageId, setSelectedImageId] = useState<string | null>(null);
  const handleImageSelect = (imageId: string) => {
    setSelectedImageId(imageId);
  };
  const handleSubmit = () => {
    if (selectedImageId) {
      onSelect(selectedImageId);
    }
  };
  return <Modal open={open} handleBackdropClick={onClose} data-sentry-element="Modal" data-sentry-component="ImageSelectionModal" data-sentry-source-file="index.tsx">
            <Styled.ModalContent data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <CompetitionGallery gallerySubtitle="Select an Image" userGallery={userGallery} defaultFilters={defaultFilters} doAction={handleImageSelect} createdAtBefore={createdAtBefore} data-sentry-element="CompetitionGallery" data-sentry-source-file="index.tsx" />
                <Styled.ButtonContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Button variant={ButtonType.SECONDARY} onClick={handleSubmit} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        Submit
                    </Button>
                    <Button variant={ButtonType.PRIMARY} onClick={onClose} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        Cancel
                    </Button>
                </Styled.ButtonContainer>
            </Styled.ModalContent>{" "}
        </Modal>;
};
export default ImageSelectionModal;